import React, { useEffect, useState } from "react";
import { Chart } from "react-google-charts";
import cdpService from "../../../apiService/cdp.service";
import Loader from "../../Global/Loader";

const WeeklySignupTrendChart = ({ filters = {} }) => {
  const [weeklySignupData, setWeeklySignupData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchWeeklySignupData();
  }, [filters]); // Re-fetch when filters change
  
  const fetchWeeklySignupData = async () => {
    setLoading(true);
    setError(null);

    try {
      const requestBody = Object.keys(filters).length > 0 ? filters : {};

      const response = await cdpService.getWeeklySignupTrend(requestBody);

      if (response.data.success) {
        let trendData = response.data.data.signupTrend.map((item) => [
          item.day, // Displaying full date instead of short weekday
          item.count,
          `Signups on ${item.day}: ${item.count}`,
        ]);

        const updatedData = [["Date", "Signups", { role: "tooltip" }], ...trendData];
        
        setWeeklySignupData((prevData) =>
          JSON.stringify(prevData) === JSON.stringify(updatedData) ? prevData : updatedData
        );
      } else {
        throw new Error("Failed to fetch data");
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const WeeklyTrendOptions = {
    legend: { position: "none" },
    format:'decimal',
    hAxis: {
      title: "Date",
      format: "dd-MM",
     },
    vAxis: {
      title: "Signups",
      minValue: 0,
      gridlines: { count: 5 },
    },
    colors: ["#4285F4"],
    tooltip: { isHtml: true, trigger: "focus" },
    bar: { groupWidth: "50%" },
  };

  if (loading) return <Loader/>;
  if (error) return <p>Error loading weekly signup trends: {error}</p>;

  return (
    <>
     <Chart
      chartType="ColumnChart"
      width="100%"
      height="350px"
      data={weeklySignupData}
      options={WeeklyTrendOptions}
    />
    </>
  );
};

export default WeeklySignupTrendChart;
